// @ts-nocheck
import { get } from 'lodash-es';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import {
  HttpHandler, HttpInterceptor, HttpRequest, HttpEvent,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RestApiService } from '../service/rest-api.service';

@Injectable()
export class PreconditionFailedInterceptor implements HttpInterceptor {
  constructor(
    private restApi: RestApiService,
  ) {
  }

  /**
   *
   */
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
    // is rest api request
    if (this.requestUrlIncludes(request, this.restApi.url)) {
      // intercept request
      return next
        .handle(request)
        .pipe(catchError((error) => {
          // intercept only 412 error codes
          if (error.status !== 412) {
            return throwError(error);
          }
          // replace expired token with valid token
          this.restApi.accreditation = {
            ...this.restApi.accreditation,
            token: get(error, 'token') || get(error, 'error.token'),
          };
          // return request with auth
          return next
            .handle(this
              .addAuthenticationToken(request));
        }));
    }
    // not rest api, nothing to do
    return next
      .handle(request);
  }

  /**
   * clone request with auth
   */
  private addAuthenticationToken(request: HttpRequest<unknown>, token: string = this.restApi.accreditation?.token): HttpRequest<unknown> {
    const headers: { [key: string]: string } = request.headers
      .keys()
      .reduce((obj, key) => ({ ...obj, [key]: request.headers.get(key) }), {});
    //
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    } else {
      delete headers.Authorization;
    }
    //
    return request.clone({
      setHeaders: headers,
    });
  }

  /**
   * is whitelisted url
   */
  private requestUrlIncludes(request: HttpRequest<unknown>, segments: string | string[]): boolean {
    return Array.isArray(segments)
      ? segments.reduce((includes, segment) => includes || request.url.includes(segment), false)
      : request.url.includes(segments);
  }
}
